import * as React from 'react';

export type RadioButtonPosition = 'left' | 'right';
export type RadioButtonVerticalPosition = "top" | "center";

export interface IRadionButtonProps {
    isChecked: boolean;
    isDisabled?: boolean;
    position?: RadioButtonPosition;
    verticalPosition?: RadioButtonVerticalPosition;
    customClass?: string;
    RoleForTest?: string;
    onClickBeforeChange?: (evt: React.MouseEvent) => void;
    onChangehandler: () => void;
}


export const RadioButton: React.FC<IRadionButtonProps> = (props) => {
    return (
        <div className={`d-flex align-items-${props.verticalPosition === 'top' ? 'top' : 'center'} fake-radio-wrapper ${props.isDisabled ? 'disabled' : ''} ${props.customClass ? props.customClass : ''}`}
            onClick={(evt) => { props.onClickBeforeChange && props.onClickBeforeChange(evt); if (!props.isDisabled) { props.onChangehandler(); } }}
            data-test-role={props.RoleForTest}
        >
            {
                props.position !== 'right' &&
                <span className={`fake-radio mr-2`}>
                    {props.isChecked && <span className="checked-radio"></span>}
                </span>
            }
            < span className="radio-button-label" > {props.children}</span >
            {
                props.position === 'right' &&
                <span className={`fake-radio ${props.isChecked ? 'checked' : ''} ml-2`}>
                    {props.isChecked && <span className="checked-radio"></span>}
                </span>
            }
        </div >
    )
}